import $ from 'jquery';
import {
  stringifyIds,
  possibleRemainingSteps,
  setInputState,
  setHelpBlock,
  validateSectionFields,
  toggleEmailPassword,
  showReviewScreen,
} from './helpers';

export default function bindAdvancedForm(
  formId,
  elements,
  translations,
  visitedSectionIds
) {
  stringifyIds(elements);

  let activeSection = elements[0];
  let readyToSubmit = false;
  let visitedSections = [activeSection];

  const $header =
    document.querySelector('#card-section-header') ||
    document.querySelector('#new_ideas_idea > h1') ||
    document.querySelector('#new_ideas_idea > h2');
  let $projectField;
  const $projectInput = document.querySelector('#project_id.project-selector');
  if ($projectInput && $projectInput.type !== 'hidden') {
    $projectField = $projectInput.parentElement.parentElement;
  }
  const $saveButton = document.querySelector('#save-button');
  const $backButton = document.querySelector('#back-button');
  const $saveAndAddProxyVoteButton = document.querySelector(
    '#save-and-add-proxy-vote-button'
  );

  const submitOnly = !document.querySelector('.new-idea-fields .found-ideas');

  let progressHtmlContainer;
  if (document.querySelector('.footer-links span')) {
    progressHtmlContainer = document.querySelector('.footer-links span');
    document
      .querySelector('.footer-links')
      .classList.add('footer-links--with-progress');
  } else {
    progressHtmlContainer = document.querySelector(
      '.dynamic-progress-container'
    );
  }
  progressHtmlContainer.innerHTML = `
  <div class="progress-section">
    <div class="progress-bar">
      <div class="progress-bar--completed"></div>
    </div>
    <div class="progress-bar--message">
      <span id="progress-number">0%</span> <span id="progress-complete"></span>
    </div>
  </div>
  `;

  document.querySelector('#progress-complete').innerText =
    translations.complete;

  const $progressCompleted = document.querySelector('.progress-bar--completed');
  const $progressNumber = document.querySelector('#progress-number');

  const setProgress = newProgress => {
    const pct = `${Math.round(newProgress * 100)}%`;
    $progressCompleted.style.width = pct;
    $progressNumber.innerText = pct;
  };

  if (visitedSectionIds) {
    visitedSections = visitedSectionIds.map(id =>
      elements.find(element => element.id === id)
    );
    activeSection = visitedSections[visitedSections.length - 1];
    showReviewScreen(
      visitedSections,
      formId,
      translations,
      $header,
      $saveButton,
      $saveAndAddProxyVoteButton
    );
    readyToSubmit = true;
    setProgress(visitedSections.length / (visitedSections.length + 1));
  }

  const setActiveSection = newActiveSection => {
    if (newActiveSection === elements[0]) {
      setProgress(0);
      document
        .querySelector('.new-idea-fields .control-group')
        .classList.remove('hidden');
      if ($projectField) {
        $projectField.classList.remove('hidden');
      }
      if (!submitOnly) {
        document
          .querySelector('.new-idea-fields .found-ideas')
          .classList.remove('hidden');
      }
    } else {
      document
        .querySelector('.new-idea-fields .control-group')
        .classList.add('hidden');
      if ($projectField) {
        $projectField.classList.add('hidden');
      }
      if (!submitOnly) {
        document
          .querySelector('.new-idea-fields .found-ideas')
          .classList.add('hidden');
      }
      const remaining =
        1 +
        possibleRemainingSteps(
          newActiveSection,
          elements,
          visitedSections.map(section => section.id)
        );
      setProgress(
        visitedSections.length / (visitedSections.length + remaining)
      );
    }
    document
      .querySelector(`#section-${activeSection.id}`)
      .classList.add('hidden');
    document
      .querySelector(`#section-${newActiveSection.id}`)
      .classList.remove('hidden');
    $header.innerText = newActiveSection.title;
    activeSection = newActiveSection;
  };

  const form = document.querySelector(formId);
  form.addEventListener('submit', event => {
    event.preventDefault();
    event.stopPropagation();

    // We will only let the submit event bubble up if it's the final submit
    // This event is used to clear any drafts that were stored
    let stopImmediatePropagation = true;

    const matchedRule = activeSection.formDefinitionRules.find(rule => {
      if (rule.ruleRole === 'default') return true;

      if (rule.fieldId) {
        // Currently the only supported static field is category.
        return rule.arrayValue.includes(
          document.querySelector('#ideas_idea_idea_category_ids')?.value
        );
      } else {
        const input = Array.from(document.querySelectorAll('input')).find(
          input => input.value === rule.customFieldDefinitionId
        );

        if (input) {
          let select = document.querySelector(
            `#${input.id.replace('custom_field_definition_id', 'option_id')}`
          );
          const selectroV2 = input.parentElement.querySelector(
            ':scope .SelectroV2__mount-container'
          );
          if (select) {
            return rule.arrayValue.includes(select.value);
          } else if (selectroV2) {
            const selectedInputs = Array.from(
              selectroV2.querySelectorAll(
                ':scope input.SelectroV2__hidden-selected-input'
              )
            );
            return selectedInputs
              .map(input => input.value)
              .some(value => rule.arrayValue.includes(value));
          } else {
            // Multiselect so we have to do more work to get the value.
            const selectNumber = input.id
              .replace('ideas_idea_custom_field_values_attributes_', '')
              .replace('_custom_field_definition_id', '');
            select = document.querySelector(
              `select[name="ideas_idea[custom_field_values_attributes][${selectNumber}][option_ids][]"]`
            );
            return Array.from(select.selectedOptions).some(option =>
              rule.arrayValue.includes(option.value)
            );
          }
        }
      }
    });

    if (readyToSubmit) {
      if (
        document.querySelector('#ideas_idea_user_email') &&
        document.querySelector('#ideas_idea_user_email').value === ''
      ) {
        setHelpBlock(document.querySelector('#email-group'), translations);
      } else if (
        document.querySelector('#ideas_portal_user_submit_form_password') &&
        document.querySelector('#ideas_portal_user_submit_form_password')
          .value === ''
      ) {
        setHelpBlock(document.querySelector('#password-group'), translations);
      } else {
        const data = Array.from(form.elements).reduce(
          (acc, el) => {
            if (el.name) {
              // Multiple select elements need to have each of their selected elements collected
              if (el.nodeName === 'SELECT' && el.multiple) {
                acc[el.name] = Array.apply(null, el.options)
                  .map(option => (option.selected ? option.value : null))
                  .filter(value => value);
              } else {
                // Attachments and SelectroV2 use the same input name so if we have multiple, each attachment overrides the previous one
                // so we create an array instead
                if (
                  /\[attachment_ids\]\[\]/.test(el.name) ||
                  el.classList.contains('SelectroV2__hidden-selected-input')
                ) {
                  if (!acc[el.name]) {
                    acc[el.name] = [el.value];
                  } else {
                    acc[el.name].push(el.value);
                  }
                } else {
                  acc[el.name] = el.value;
                }
              }
            }

            return acc;
          },
          {
            visited_section_ids: visitedSections
              .map(section => section.id)
              .join(','),
          }
        );

        if (
          $saveButton.dataset.disableWith !== undefined &&
          $saveButton.dataset.disableWith !== ''
        ) {
          $saveButton.value = $saveButton.dataset.disableWith;
        }

        $saveButton.disabled = true;

        if ($saveAndAddProxyVoteButton) {
          if (
            $saveAndAddProxyVoteButton.dataset.disableWith !== undefined &&
            $saveAndAddProxyVoteButton.dataset.disableWith !== ''
          ) {
            $saveAndAddProxyVoteButton.value =
              $saveAndAddProxyVoteButton.dataset.disableWith;
          }
          $saveAndAddProxyVoteButton.disabled = true;
        }

        // Submit via a hidden form so we can follow redirects.
        const actionWithoutQueryString = form.action.split('?')[0];
        const newForm = $('<form style="display: none;"/>')
          .attr('action', actionWithoutQueryString)
          .attr('method', 'post');
        for (const property in data) {
          // Create input elements for each value if the property is an array (eg. with multiple select elements)
          const values = Array.isArray(data[property])
            ? data[property]
            : [data[property]];

          values.forEach(value => {
            const input = $('<input />')
              .attr('id', property)
              .attr('name', property)
              .attr('value', value);

            newForm.append(input);
          });
        }
        newForm.appendTo('body').submit();

        // Let DraftManager clear the draft storage now
        stopImmediatePropagation = false;
      }
    } else {
      $backButton.disabled = false;

      switch (matchedRule?.ruleType) {
        case 'form':
          if (validateSectionFields(activeSection, translations)) {
            const newActiveSection = elements.find(
              element =>
                element.id === matchedRule.descendantFormDefinitionElementId
            );
            setActiveSection(newActiveSection);
            visitedSections.push(activeSection);
          }

          break;

        case 'message': {
          document
            .querySelector(`#section-${activeSection.id}`)
            .classList.add('hidden');
          const message = document.querySelector('#section-message');
          // Note: the body value is sanitized on the server prior to saving the rule.
          // eslint-disable-next-line no-unsanitized/property
          message.innerHTML = matchedRule.body;
          message.classList.remove('hidden');
          document
            .querySelector('.new-idea-fields .control-group')
            .classList.add('hidden');
          if ($projectField) {
            $projectField.classList.add('hidden');
          }
          if (!submitOnly) {
            document
              .querySelector('.new-idea-fields .found-ideas')
              .classList.add('hidden');
          }
          $backButton.classList.add('hidden');
          $saveButton.classList.add('hidden');
          if ($saveAndAddProxyVoteButton) {
            $saveAndAddProxyVoteButton.classList.add('hidden');
          }
          setProgress(1);
          break;
        }

        case 'submit':
          if (!validateSectionFields(activeSection, translations)) {
            break;
          }
        /* fall through */
        default:
          showReviewScreen(
            visitedSections,
            formId,
            translations,
            $header,
            $saveButton,
            $saveAndAddProxyVoteButton
          );
          readyToSubmit = true;
          setProgress(visitedSections.length / (visitedSections.length + 1));
          break;
      }
    }

    if (stopImmediatePropagation) {
      // This stops the submit handler in DraftManager from deleting a draft
      event.stopImmediatePropagation();
    }
  });

  $backButton.addEventListener('click', e => {
    e.preventDefault();

    if (readyToSubmit) {
      setInputState(formId, false);
      readyToSubmit = false;
      visitedSections.forEach(section => {
        document
          .querySelector(`#section-${section.id}`)
          .classList.add('hidden');
      });
      toggleEmailPassword(false);
      $saveButton.value = translations.next;
      if ($saveAndAddProxyVoteButton) {
        $saveButton.classList.replace('btn-outline', 'btn-primary');
        $saveAndAddProxyVoteButton.classList.add('hidden');
      }
    } else {
      visitedSections.pop();
      if (visitedSections.length === 1) {
        $backButton.disabled = true;
      }
    }

    setActiveSection(visitedSections[visitedSections.length - 1]);
  });
}
